export interface ISettings {
    NumberOfMissingNumbers: number;
    NumberOfPages: number;
    IsMultiplicationChart: boolean;
}

export const DefaultSettings: ISettings = {
    NumberOfMissingNumbers: 0,
    NumberOfPages: 1,
    IsMultiplicationChart: false
}

export const MissingNumberOptions: number[] = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
